import { TitleCasePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog as MatDialog,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { VerbatimModalComponent } from "../../verbatims/verbatim-modal/verbatim-modal.component";
import {
  Expression,
  OperandType,
  OperatorType,
  PaginatedHit,
  VerbatimDetailsModal,
} from "../category-builder.models";
import { ExpressionLabelPipe } from "../expression-label.pipe";

@Component({
  selector: "app-expression-explorer",
  templateUrl: "./expression-explorer.component.html",
  styleUrls: ["./expression-explorer.component.scss"],
  standalone: false,
})
export class ExpressionExplorerComponent implements OnInit {
  title = "";
  selectedSentence: PaginatedHit = null;
  displayingDeltaPlusMinusSentences: boolean;
  displayingChipotletSentences: boolean;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      expression: Expression;
      displayDeltaPlus: boolean;
      displayChipotletSentences: boolean;
    },
    private titleCasePipe: TitleCasePipe,
    private expressionLabelPipe: ExpressionLabelPipe,
  ) {}

  ngOnInit(): void {
    const isOperator = Object.values(OperatorType).some(
      (v) => v === this.data.expression.type,
    );
    this.title = this.titleCasePipe.transform(
      isOperator
        ? `Group: ${this.data.expression.label || "Unnamed Group"}`
        : `${this.expressionLabelPipe.singular(
            this.data.expression.type as OperandType,
          )} : ${this.data.expression.value}`,
    );

    if (this.data.displayDeltaPlus) {
      this.title = "Sentences Added";
      this.displayingDeltaPlusMinusSentences = true;
    } else if (this.data.displayDeltaPlus === false) {
      this.title = "Sentences Removed";
      this.displayingDeltaPlusMinusSentences = true;
    } else if (this.data.displayChipotletSentences) {
      this.displayingChipotletSentences = true;
    }
  }

  setSelectedSentence(sentence: PaginatedHit) {
    const sentenceAndVerbatimDetails = {
      verbatim: {
        verbatim: sentence.source.verbatim,
        verbatimId: sentence.source.verbatim_id,
        categoryNames: undefined,
      },
      sentence: {
        label: "Sentence Details",
        sentences: [sentence.source],
        hashes: undefined,
        lookup: undefined,
      },
      structuredData: {
        structuredData: sentence.source.structured_data,
        fieldGroups: undefined,
      },
    } as VerbatimDetailsModal;

    this.dialog.open(VerbatimModalComponent, {
      data: sentenceAndVerbatimDetails,
      width: "600px",
      maxHeight: "800px",
    });
  }
}
